export default __webpack_public_path__ + "static/media/avatar_64.6cc2b204.png";